export default __webpack_public_path__ + "static/media/logo-white.b38593ba.png";